export type PlaygroundGame = {
  id: string;
  name: string;
  description: string;
  emoji: string;
  route: string;
  tags: string[];
  gradient: string;
  accent: string;
};

export const PLAYGROUND_GAMES: PlaygroundGame[] = [
  {
    id: 'tri-wishes',
    name: 'Три Желания',
    description: 'Кликай и копи деньги, здоровье и любовь — соревнуйся в таблице чемпионов',
    emoji: '✨',
    route: '/app/playground/tri-wishes',
    tags: ['кликер', 'рейтинг'],
    gradient: 'linear-gradient(145deg, #fff1f2 0%, #fce7f3 45%, #fdf4ff 100%)',
    accent: '#db2777',
  },
  {
    id: 'forest-quest',
    name: 'Лес Трёх Желаний',
    description:
      'RPG-кампания в магическом лесу: пожелания из кликера становятся силой отряда. Создатель открывает портал — новые герои могут выйти из тумана в любой момент.',
    emoji: '🌲',
    route: '/app/playground/forest-quest',
    tags: ['квест', 'кооп'],
    gradient: 'linear-gradient(145deg, #ecfdf5 0%, #d1fae5 45%, #ecfccb 100%)',
    accent: '#059669',
  },
];

export function getPlaygroundGame(id: string) {
  return PLAYGROUND_GAMES.find((game) => game.id === id);
}
